import equal from "deep-equal";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { createEnumParam, useQueryParams, withDefault } from "use-query-params";

import Tabs from "@components/buttons/Tabs";
import styles from "@components/forms/ExploreFilters.module.css";
import Form from "@components/forms/Form";
import { LibraryTabEnum } from "@typing/Enums";

type FormData = {
  tab: LibraryTabEnum;
};

type Props = {
  filters: FormData;
  onChange: (filterValues: FormData) => void;
};

const ExploreFilters = ({ filters, onChange }: Props) => {
  const libraryTabParam = createEnumParam<LibraryTabEnum>(Object.values(LibraryTabEnum));

  const [query, setQuery] = useQueryParams({
    tab: withDefault({ ...libraryTabParam, urlName: "exploreTab" }, filters.tab)
  });

  const defaultValues: FormData = query;

  const form = useForm<FormData>({
    defaultValues,
    mode: "onChange"
  });

  const tab = form.watch("tab");

  useEffect(() => {
    const values = { tab };

    if (!equal(values, filters)) {
      setQuery(values);
      onChange(values);
    }
  }, [filters, onChange, setQuery, tab]);

  const tabOptions = useMemo(() => {
    const values = [LibraryTabEnum.MEDIA, LibraryTabEnum.EVENTS, LibraryTabEnum.PINS];

    const options = values.map(option => ({
      textKey: `models.explore.tab.${option}`,
      value: option
    }));
    return options;
  }, []);

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Form className={styles.form} hookForm={form} onSubmit={() => {}}>
      <div>
        <Tabs onChange={v => form.setValue("tab", v, { shouldTouch: true })} options={tabOptions} value={tab} />
      </div>
    </Form>
  );
};

export default ExploreFilters;
